import { isObject } from "./helpers"

export default class TranslationController {
	name = "translationController"

	_languages = []

	_selectedLanguage = ""

	static _localStoragePrefix = "b1_"

	static _localStorageLanguageKey = `${this._localStoragePrefix}language`

	static get localStorageLanguageKey() {
		return TranslationController._localStorageLanguageKey
	}

	get languages() {
		return this._languages
	}

	// private _translations: Map<TranslationControllerLanguagesKeys, TranslationType>[] = []
	_translations = {}

	get translations() {
		return this._translations
	}

	get selectedLanguage() {
		return this._selectedLanguage
	}

	/*
    
		  Se l'oggetto è nested (es: 
		  {
			  pippo: "franco", 
			  amici: 
				  {luca: "rossi"}
			  }
		  }
  
		  ritorna un oggetto di tipo:
		  {
			  "pippo":"franco",
			  "amici.luca": "rossi"
		  }
    
	  */

	flattenTranslationObject(translation = {}, prefix = "") {
		const keys = Object.keys(translation)

		let result = {}

		for (const key of keys) {
			const newKey = prefix ? `${prefix}.${key}` : key

			const el = translation[key]

			if (!isObject(el)) result[newKey] = el
			else {
				const flattened = this.flattenTranslationObject(el, newKey)

				result = { ...result, ...flattened }
			}
		}

		return result
	}

	getTranslation(language, translationKey) {
		return this._translations[language].get(translationKey) ?? null
	}

	setLanguages(languages) {
		this._languages = languages
	}

	setSelectedLanguage(language) {
		localStorage.setItem(
			TranslationController.localStorageLanguageKey,
			language
		)
		this._selectedLanguage = language
	}

	setTranslations(translations) {
		if (this._languages.length != translations.length)
			return this.handleErrors("languagesTranslationsDifference")

		for (let i = 0; i < this._languages.length; i++) {
			const map = new Map()

			const language = this._languages[i]
			const translation = this.flattenTranslationObject(translations[i])

			this._translations[language] = map

			const translationKeys = Object.keys(translation)

			for (const key of translationKeys) {
				const data = translation[key]

				map.set(key, data)
			}
		}
	}

	handleErrors(errorType) {
		if (errorType === "languagesTranslationsDifference") {
			console.error(
				"The number of languages and translations doesn't match! \nCant' proceed with traduction"
			)
		}

		return
	}
}